export default __webpack_public_path__ + "static/0064-de83f26c3997fed061c02c98fc378980.png";